/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

export const useModalStore = defineStore({
  id: 'modal',
  state: () => ({
    actionModal: {
      toShow: false,
      options: {
        title: '',
        text: '',
        primaryBtnText: null,
        primaryBtnAction: null,
        secondaryBtnText: null,
        secondaryBtnAction: null,
        alignment: {},
      },
    },

    walletModal: {
      toShow: false,
      options: {
        primaryBtnAction: null,
        secondaryBtnAction: null,
        alignment: {},
      },
    },

    formComponentModal: {
      toShow: false,
      options: {
        primaryBtnAction: null,
        secondaryBtnAction: null,
        componentPath: '',
        alignment: {
          overflow: 'scroll',
          'justify-content': 'center',
          'align-content': 'start',
        },
      },
    },

    dofpFailureModal: {
      toShow: false,
      options: {
        body: '',
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    dofpNotifyModal: {
      toShow: false,
      type: 'notify',
      options: {
        primaryBtnText: null,
        primaryBtnAction: null,
        secondaryBtnText: null,
        secondaryBtnAction: null,
        alignment: {},
      },
    },

    orderRecoveryModal: {
      toShow: false,
      options: {
        primaryBtnAction: null,
        secondaryBtnAction: null,
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    redirectModal: {
      toShow: false,
      options: {
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    euCoinRestrictionModal: {
      toShow: false,
      options: {
        primaryBtnAction: null,
        secondaryBtnAction: null,
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    paymentAttemptModal: {
      toShow: false,
      options: {
        title: '',
        text: '',
        alertText: '',
        alertType: 'warning',
        primaryBtnText: null,
        primaryBtnAction: null,
        secondaryBtnText: null,
        secondaryBtnAction: null,
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    paymentSwitchLoading: false,

    paymentPersonalDetailsModal: {
      toShow: false,
      options: {
        pspName: '',
        onSubmit: null,
        onGoBack: null,
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    paymentPurposeOfTxModal: {
      toShow: false,
      options: {
        pspName: '',
        onSubmit: null,
        onGoBack: null,
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    paymentKycModal: {
      toShow: false,
      options: {
        pspName: '',
        componentPath: '',
        fieldLabel: '',
        fieldName: 'kyc-field',
        fieldType: 'text',
        fieldPlaceholder: '',
        fieldValue: '',
        fieldError: '',
        fieldTooltip: '',
        onSubmit: null,
        onGoBack: null,
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    paymentFailureModal: {
      toShow: false,
      options: {
        onSwitchMethod: null,
        onTryAgain: null,
        errorCode: '',
        errorMessage: '',
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

    paymentMethodSwitchModal: {
      toShow: false,
      options: {
        paymentMethods: [],
        selectedPaymentCode: '',
        failedPaymentCode: '',
        onSelect: null,
        onContinue: null,
        onGoBack: null,
        alignment: {
          'justify-content': 'center',
          'align-content': 'center',
        },
      },
    },

  }),
  actions: {

    /**
     * Toggles the visibility of the wallet modal.
     *
     * @param {boolean} toShow - Whether the modal should be visible or not.
     */

    toggleWalletModal(toShow) {
      this.walletModal.toShow = toShow;
    },

    toggleEuCoinRestrictionModal(toShow) {
      this.euCoinRestrictionModal.toShow = toShow;
    },

    setPaymentSwitchLoading(value) {
      this.paymentSwitchLoading = value;
    },

    togglePaymentFailureModal(toShow, opts = {}) {
      this.paymentFailureModal.toShow = toShow;
      this.paymentFailureModal.options = {
        ...this.paymentFailureModal.options,
        ...opts,
      };
    },

    togglePaymentKycModal(toShow, opts = {}) {
      this.paymentKycModal.toShow = toShow;
      this.paymentKycModal.options = {
        ...this.paymentKycModal.options,
        ...opts,
      };
    },

    togglePaymentMethodSwitchModal(toShow, opts = {}) {
      this.paymentMethodSwitchModal.toShow = toShow;
      this.paymentMethodSwitchModal.options = {
        ...this.paymentMethodSwitchModal.options,
        ...opts,
      };
    },

    setPaymentMethodSwitchSelectedCode(code) {
      this.paymentMethodSwitchModal.options.selectedPaymentCode = code;
    },
  },
  getters: {
    getActionModalData(store) {
      return store.actionModal;
    },
    showModal() {
      if (this.paymentSwitchLoading) return true;

      return Object.keys(this.$state).filter(
        (modal) => this.$state[modal].toShow === true,
      ).length > 0;
    },
  },
});
